module.exports = __webpack_public_path__ + "static/media/5.86242661.jpg";